import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer'

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#F5F5F5',
  },
  section: {
    margin: 10,
    padding: 10,
    border: 1,
    borderColor: 'rgba(0, 0, 0, 0.125)',
    borderRadius: 5,
    borderStyle: 'solid',
    backgroundColor: '#fff',
    borderWidth: 0.5,
  },
  sectionTable: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 10,
  },
  sectionTableImg: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  sectionTableRow: {
    flex: 1,
    border: 0,
    padding: 0,
    paddingTop: 5,
    paddingBottom: 5,
  },
  titleHeader: {
    fontSize: 22,
    textAlign: 'left',
    marginBottom: 20,
    fontWeight: 'bold',
    color: '#4B5563',
    marginTop: 20,
    marginLeft: 10,
  },
  title: {
    fontSize: 22,
    textAlign: 'left',
    marginBottom: 20,
    fontWeight: 'bold',
    color: '#4B5563',
    borderBottom: '1px solid #4B5563',
    paddingBottom: 7,
  },
  subtitle: {
    fontSize: 14,
    textAlign: 'left',
    marginBottom: 1,
    fontWeight: 'normal',
    color: '#4B5563',
  },
  text: {
    fontSize: 16,
    textAlign: 'left',
    marginBottom: 0,
    fontWeight: 'normal',
    color: '#4B5563',
  },
  imageMap: {
    width: '100%',
    height: '200px',
    objectFit: 'cover',
    borderRadius: 8,
    margin: 0,
    padding: 0,
  },
})

const webChannels = ['web', 'web_gestor', 'web_anonymous']

export const PdfGeneratorReports = ({
  title = '',
  pageSize = 'A4',
  pageOrientation,
  data = {
    general: {
      category: {
        name: null,
        icon: null,
      },
      subcategory: {
        name: null,
        icon: null,
      },
      status: null,
      start_date: null,
      due_date: null,
      completed_at: null,
      planning_date: null,
      jurisiction: null,
      sub_juristiction: null,
      user_report: {
        type: null,
        name: null,
      },
      data_form_json: [],
      channel_capture: null,
    },
    address: {
      street: null,
      zipcode: null,
      state: null,
      city: null,
      reference: null,
      latitude: null,
      longitude: null,
      url: null,
      address_full: null,
    },
    user_report: {
      channel_capture: null,
      name: null,
      email: null,
      phone: null,
      address: null,
    },
    user_responsible: {
      name: null,
      email: null,
      charge: null,
    },
    attachments: [],
  },
  filters = {
    generalData: true,
    location: true,
    requesterData: true,
    responsibleData: true,
    evidence: true,
  },
  pages = {
    generalData: true,
    location: true,
    requesterData: true,
    responsibleData: true,
    evidence: true,
  },
}) => {
  return (
    <Document>
      <Page size={pageSize} style={styles.page} orientation={pageOrientation}>
        <Text style={styles.titleHeader}>{title}</Text>
        {/**--------- DATOS GENERALES ----------- */}
        {filters.generalData && (
          <View style={styles.section}>
            <Text style={styles.title}>Datos generales</Text>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Categoría</Text>
                <Text style={styles.text}>{data?.general?.category?.name}</Text>
              </View>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Sub Categoría</Text>
                <Text style={styles.text}>
                  {data?.general?.subcategory?.name}
                </Text>
              </View>
            </View>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Status</Text>
                <Text style={styles.text}>{data?.general?.status}</Text>
              </View>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Fecha inicio</Text>
                <Text style={styles.text}>{data?.general?.start_date}</Text>
              </View>
            </View>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Fecha final</Text>
                <Text style={styles.text}>{data?.general?.due_date}</Text>
              </View>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Fecha de completado</Text>
                <Text style={styles.text}>{data?.general?.completed_at}</Text>
              </View>
            </View>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Fecha de planificacion</Text>
                <Text style={styles.text}>{data?.general?.planning_date}</Text>
              </View>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Jurisdiccion</Text>
                <Text style={styles.text}>{data?.general?.jurisiction}</Text>
              </View>
            </View>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Zona</Text>
                <Text style={styles.text}>
                  {data?.general?.sub_juristiction}
                </Text>
              </View>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>
                  {data?.general.user_report?.type}
                </Text>
                <Text style={styles.text}>
                  {data?.general?.user_report?.name}
                </Text>
              </View>
            </View>

            {data?.general?.data_form_json?.length > 0 &&
              data.general.data_form_json.map((item, index) => (
                <View key={index} style={styles.sectionTable}>
                  {Object.entries(item).map(([key, value]) => (
                    <View key={key} style={styles.sectionTableRow}>
                      <Text style={styles.subtitle}>{key}</Text>
                      <Text style={styles.text}>{value}</Text>
                    </View>
                  ))}
                </View>
              ))}
          </View>
        )}

        {/**--------- SALTO DE PAGINA ----------- */}
        {pages.generalData && <View break />}

        {/* <View break /> */}
        {/**--------- UBICACION ----------- */}
        {filters.location && (
          <View style={styles.section}>
            <Text style={styles.title}>Ubicación</Text>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Dirección</Text>
                <Text style={styles.text}>
                  {/* {data?.address?.street ? `${data.address.street}, ` : ''}
                  {data?.address?.zipcode
                    ? `C.P. ${data.address.zipcode}, `
                    : ''}
                  {data?.address?.city ? `${data.address.city}, ` : ''}
                  {data?.address?.state ? `${data.address.state} ` : ''} */}
                  {data &&
                  data.user_report &&
                  data.user_report.channel_capture === 'app' ? (
                    <>{data.address.street || 'no street'}</>
                  ) : (
                    <>{data.address.address_full || 'no address full'}</>
                  )}
                </Text>
              </View>
            </View>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Referencia</Text>
                <Text style={styles.text}>{data?.address?.reference}</Text>
              </View>
            </View>

            {data?.address?.url && (
              <Image src={data.address.url} style={styles.imageMap} />
            )}
          </View>
        )}

        {/**--------- SALTO DE PAGINA ----------- */}
        {pages.location && <View break />}

        {/**--------- DATOS DEL SOLICITANTE ----------- */}
        {filters.requesterData && (
          <View style={styles.section}>
            <Text style={styles.title}>Datos del Solicitante</Text>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Canal aviso</Text>
                <Text style={styles.text}>
                  {data?.user_report?.channel_capture === 'app'
                    ? 'App'
                    : webChannels.includes(data?.user_report?.channel_capture)
                    ? 'Web'
                    : 'TlajoChat'}
                </Text>
              </View>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Nombre</Text>
                <Text style={styles.text}>{data?.user_report?.name}</Text>
              </View>
            </View>
            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Correo</Text>
                <Text style={styles.text}>{data?.user_report?.email}</Text>
              </View>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Teléfono</Text>
                <Text style={styles.text}>{data?.user_report?.phone}</Text>
              </View>
            </View>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Dirección</Text>
                <Text style={styles.text}>{data?.user_report?.address}</Text>
              </View>
            </View>
          </View>
        )}

        {/**--------- SALTO DE PAGINA ----------- */}
        {pages.requesterData && <View break />}

        {/**--------- DATOS DEL RESPONSABLE ----------- */}
        {filters.responsibleData && (
          <View style={styles.section}>
            <Text style={styles.title}>Datos del Responsable</Text>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Nombre</Text>
                <Text style={styles.text}>{data?.user_responsible?.name}</Text>
              </View>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Correo</Text>
                <Text style={styles.text}>{data?.user_responsible?.email}</Text>
              </View>
            </View>

            <View style={styles.sectionTable}>
              <View style={styles.sectionTableRow}>
                <Text style={styles.subtitle}>Cargo</Text>
                <Text style={styles.text}>
                  {data?.user_responsible?.charge}
                </Text>
              </View>
            </View>
          </View>
        )}

        {/**--------- SALTO DE PAGINA ----------- */}
        {pages.responsibleData && <View break />}

        {/**--------- EVIDENCIA ----------- */}
        {filters.evidence && (
          <View style={styles.section}>
            <Text style={styles.title}>Evidencia</Text>
            {data?.attachments.length > 0 &&
              data?.attachments.map((attachment, index) => (
                <View key={index} style={styles.sectionTableImg}>
                  <Text style={styles.subtitle}>
                    Adjunto {index + 1}: {attachment.user?.name} (
                    {attachment.user?.rol})
                  </Text>

                  {attachment.urls.map((url, idx) => (
                    <View key={idx} style={{ marginBottom: 10 }}>
                      <Image style={styles.imageMap} src={url} />
                    </View>
                  ))}
                </View>
              ))}
          </View>
        )}

        {/**--------- SALTO DE PAGINA ----------- */}
        {pages.evidence && <View break />}
      </Page>
    </Document>
  )
}
